import { v4 as UUID } from 'uuid'

import { AreaLabelResponse, Policy_KindEnum, PolicyRule_RuleUnitsEnum } from 'src/api/gen'
import {
  IPolicyRuleAbandoned,
  IPolicyRuleAbsoluteFleetSize,
  IPolicyRuleBalancing,
  IPolicyRuleBeginnerAllowedHours,
  IPolicyRuleBeginnerSpeedLimit,
  IPolicyRuleFleetBudget,
  IPolicyRuleDwellTime,
  IPolicyRuleGeofence,
  IPolicyRuleMaintenance,
  IPolicyRuleParking,
  IPolicyRulePermit,
  IPolicyRuleSidewalk,
  IPolicyRuleSpeed,
  IPolicyRuleTime,
  IPolicyRuleTripTaxation,
  IPolicyRuleUser,
  IPolicyRuleVehicleDeployment,
  PolicyRule,
} from 'src/api/types/policy'
import PermitRule from 'src/pages/FeeRates/Editor/Rules/PermitRule'
import TripTaxationRule from 'src/pages/FeeRates/Editor/Rules/TripTaxationRule'
import VehicleDeploymentRule from 'src/pages/FeeRates/Editor/Rules/VehicleDeploymentRule'
import AbsoluteFleetSizeRule from 'src/pages/Policies/Editor/Rules/AbsoluteFleetSizeRule'
import BaseRule from 'src/pages/Policies/Editor/Rules/BaseRule'
import BeginnerAllowedHoursRule from 'src/pages/Policies/Editor/Rules/BeginnerAllowedHoursRule'
import BeginnerSpeedLimitRule from 'src/pages/Policies/Editor/Rules/BeginnerSpeedLimitRule'
import DwellTimeRule from 'src/pages/Policies/Editor/Rules/DwellTimeRule'
import FleetBudgetRule from 'src/pages/Policies/Editor/Rules/FleetBudgetRule'
import GeofenceRule from 'src/pages/Policies/Editor/Rules/GeofenceRule'
import MaintenanceRule from 'src/pages/Policies/Editor/Rules/MaintenanceRule'
import ParkingRule from 'src/pages/Policies/Editor/Rules/ParkingRule'
import SpeedLimitRule from 'src/pages/Policies/Editor/Rules/SpeedLimitRule'

import { assertUnreachable } from '../typeHelpers'

import { TRulesValidation } from './RulesValidation'

export const initialAbsoluteFleetSizeRule: IPolicyRuleAbsoluteFleetSize = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.absolute_fleet_size,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  minimum: 0,
  maximum: 0,
}

export const initialFleetBudgetRule: IPolicyRuleFleetBudget = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.fleet_budget,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  rate_amount: 0,
  maximum: 0,
}

export const initialPermitRule: IPolicyRulePermit = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.permit,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  minimum: 0,
  maximum: 0,
  rate_amount: 0,
  proration_kind: undefined,
  proration_areas_mapping: undefined,
  proration_time_spent_report_area: undefined,
}

export const initialGeofenceRule: IPolicyRuleGeofence = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.geofence,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
}

export const initialSpeedRule: IPolicyRuleSpeed = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.speed,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  maximum: 0,
  buffer_speed: 0,
  rule_units: PolicyRule_RuleUnitsEnum.kmh,
}

export const initialParkingRule: IPolicyRuleParking = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.parking,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  rule_units: PolicyRule_RuleUnitsEnum.minutes,
  authorized_parking_zones: [],
  buffered_authorized_parking_zones: [],
  buffered_prohibited_parking_zones: [],
  prohibited_parking_zones: [],
}

export const initialTripTaxationRule: IPolicyRuleTripTaxation = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.trip_taxation,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  rate_amount: 0,
  rate_amount_type: 'fee',
  rule_units: PolicyRule_RuleUnitsEnum.amount,
  proration_kind: undefined,
  proration_areas_mapping: undefined,
  proration_time_spent_report_area: undefined,
}

export const initialBeginnerSpeedLimitRule: IPolicyRuleBeginnerSpeedLimit = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.beginner_speed_limit,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  maximum: 0,
  timeslots: [],
  rule_units: PolicyRule_RuleUnitsEnum.kmh,
}

export const initialBeginnerAllowedHoursRule: IPolicyRuleBeginnerAllowedHours = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.beginner_allowed_hours,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
}

// Not implemented yet, for demo purpose only
export const initialTimeRule: IPolicyRuleTime = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.time,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  minimum: undefined,
  maximum: undefined,
  rule_units: undefined,
}

// Not implemented yet, for demo purpose only
export const initialUserRule: IPolicyRuleUser = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.user,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  minimum: undefined,
  maximum: undefined,
}

// Not implemented yet, for demo purpose only
export const initialAbandonedRule: IPolicyRuleAbandoned = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.abandoned,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
}

// Not implemented yet, for demo purpose only
export const initialSidewalkRule: IPolicyRuleSidewalk = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.sidewalk,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
}

// Not implemented yet, for demo purpose only
export const initialBalancingRule: IPolicyRuleBalancing = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.balancing,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
}

export const initialVehicleDeploymentRule: IPolicyRuleVehicleDeployment = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.vehicle_deployment,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  rate_amount: 0,
  proration_kind: undefined,
  proration_areas_mapping: undefined,
  proration_time_spent_report_area: undefined,
}

export const initialMaintenanceRule: IPolicyRuleMaintenance = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.maintenance,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  minimum: 30,
  maximum: 1,
  rule_units: PolicyRule_RuleUnitsEnum.days,
}

export const initialDwellTimeRule: IPolicyRuleDwellTime = {
  name: '',
  rule_id: '',
  rule_type: Policy_KindEnum.dwell_time,
  geographies: [],
  buffered_geographies: [],
  vehicle_types: [],
  timeslots: [],
  rule_units: PolicyRule_RuleUnitsEnum.minutes,
  authorized_parking_zones: [],
  buffered_authorized_parking_zones: [],
  buffered_prohibited_parking_zones: [],
  prohibited_parking_zones: [],
}

export const initialiseRule = function (kind: Policy_KindEnum): PolicyRule {
  const getRule = () => {
    switch (kind) {
      case Policy_KindEnum.absolute_fleet_size:
        return initialAbsoluteFleetSizeRule
      case Policy_KindEnum.geofence:
        return initialGeofenceRule
      case Policy_KindEnum.speed:
        return initialSpeedRule
      case Policy_KindEnum.parking:
        return initialParkingRule
      case Policy_KindEnum.time:
        return initialTimeRule
      case Policy_KindEnum.fleet_budget:
        return initialFleetBudgetRule
      case Policy_KindEnum.user:
        return initialUserRule
      case Policy_KindEnum.abandoned:
        return initialAbandonedRule
      case Policy_KindEnum.trip_taxation:
        return initialTripTaxationRule
      case Policy_KindEnum.sidewalk:
        return initialSidewalkRule
      case Policy_KindEnum.balancing:
        return initialBalancingRule
      case Policy_KindEnum.beginner_speed_limit:
        return initialBeginnerSpeedLimitRule
      case Policy_KindEnum.beginner_allowed_hours:
        return initialBeginnerAllowedHoursRule
      case Policy_KindEnum.permit:
        return initialPermitRule
      case Policy_KindEnum.vehicle_deployment:
        return initialVehicleDeploymentRule
      case Policy_KindEnum.maintenance:
        return initialMaintenanceRule
      case Policy_KindEnum.dwell_time:
        return initialDwellTimeRule
      default:
        return assertUnreachable(kind)
    }
  }
  return { ...getRule(), rule_id: UUID() }
}

export interface IBaseTableProps<RuleType extends PolicyRule> {
  allGeographies: AreaLabelResponse[]
  currencySymbol?: string
  disabled: boolean
  handleChange: (rules: RuleType[]) => void
  handleDelete?: (ruleId: string) => () => void
  handleRemoveTimeSlot: (timeslotIndex: number) => void
  isPublished: boolean
  policyIsPermit: boolean
  resetRules?: (rules: RuleType[]) => void
  ruleType: RuleType['rule_type']
  rules: RuleType[] | [RuleType]
  validation: TRulesValidation[]
}

export type RulesTable<RuleType extends PolicyRule> = (props: IBaseTableProps<RuleType>) => JSX.Element

export const TABLE_PER_RULE_TYPE: {
  [policy in Policy_KindEnum]: RulesTable<any> | null
} = {
  [Policy_KindEnum.absolute_fleet_size]: AbsoluteFleetSizeRule,
  [Policy_KindEnum.fleet_budget]: FleetBudgetRule,
  [Policy_KindEnum.permit]: PermitRule,
  [Policy_KindEnum.geofence]: GeofenceRule,
  [Policy_KindEnum.speed]: SpeedLimitRule,
  [Policy_KindEnum.parking]: ParkingRule,
  [Policy_KindEnum.abandoned]: BaseRule,
  [Policy_KindEnum.trip_taxation]: TripTaxationRule,
  [Policy_KindEnum.sidewalk]: BaseRule,
  [Policy_KindEnum.balancing]: BeginnerAllowedHoursRule,
  [Policy_KindEnum.beginner_speed_limit]: BeginnerSpeedLimitRule,
  [Policy_KindEnum.beginner_allowed_hours]: BeginnerAllowedHoursRule,
  [Policy_KindEnum.time]: null, // not implemented yet
  [Policy_KindEnum.user]: null, // not implemented yet
  [Policy_KindEnum.vehicle_deployment]: VehicleDeploymentRule,
  [Policy_KindEnum.maintenance]: MaintenanceRule,
  [Policy_KindEnum.dwell_time]: DwellTimeRule,
}
